import { Config, sanitize as htmlSanitize } from "dompurify"

/*
    Simple decorator for dompurify to be sure, that only valid HTML is returned even if you forgot to define the profiles.
    For more information see https://github.com/cure53/DOMPurify#can-i-configure-dompurify
 */
export const sanitize = (dirtyHtml: string | Node, config?: Config): string | HTMLElement | DocumentFragment | null => {
    return htmlSanitize(dirtyHtml, { ...config }) || null
}
